import { Facebook, Instagram, Twitter } from '@/assets'
import { ROUTES } from '@/utils'

export const copyRightLinks = [
  { name: 'Privacy', link: ROUTES.PRIVACY },
  {
    name: 'TICO #50024262',
    link: 'https://members.tico.ca/TICO/Search/DirectoryDetails.aspx?ID=50024261',
  },
]
export const linksData = [
  {
    title: 'Company',
    links: [
      { name: 'About Us', link: ROUTES.ABOUT_US },
      { name: 'Contact Us', link: ROUTES.CONTACT_US },
      { name: 'Groups (7+)', link: ROUTES.GROUPS },
      // { name: 'Travel', link: ROUTES.TRAVEL }, //TODO: Uncomment once travel module is integrated
    ],
  },
  {
    title: 'Tickets',
    links: [
      { name: 'NFL Tickets', link: '/nfl-tickets' },
      { name: 'MLB Tickets', link: '/mlb-tickets' },
      { name: 'NBA Tickets', link: '/nhl-tickets' },
      { name: 'NCAA Football Tickets', link: '/college-football-tickets' },
      { name: 'NCAA Basketball Tickets', link: '/college-basketball-tickets' },
      { name: 'MLS Tickets', link: '/mls-tickets' },
      { name: 'Festival Tickets', link: '/festival-tickets' },
      { name: 'PGA Tour Tickets', link: '/pga-tour-tickets' },
      {
        name: 'UFC Tickets',
        link: '/mixed-martial-arts-tickets/ufc-ultimate-fighting-championship',
      },
    ],
  },
  {
    title: 'Teams',
    links: [
      { name: 'Dallas Cowboys Travel Packages', link: '/nfl-travel-packages/dallas-cowboys' },
      {
        name: 'New England Patriots Travel Packages',
        link: '/nfl-travel-packages/new-england-patriots',
      },
      { name: 'New York Giants Travel Packages', link: '/nfl-travel-packages/new-york-giants' },
      {
        name: 'San Francisco 49ers Travel Packages',
        link: '/nfl-travel-packages/san-francisco-49ers',
      },
      { name: 'New York Yankees Travel Packages', link: '/mlb-travel-packages/new-york-yankees' },
      {
        name: 'Los Angeles Lakers Travel Packages',
        link: '/nba-travel-packages/los-angeles-lakers',
      },
      { name: 'New York Knicks Travel Packages', link: '/nba-travel-packages/new-york-knicks' },
      {
        name: 'New York Rangers Travel Packages',
        link: '/nhl-travel-packages/new-york-rangers',
      },
      {
        name: 'Toronto Maple Leafs Travel Packages',
        link: '/nhl-travel-packages/toronto-maple-leafs',
      },
    ],
  },
  {
    title: 'Festivals',
    links: [
      { name: 'Afropunk Fest Travel Packages', link: '/afropunk-festival-travel-packages' },
      { name: 'Bonnaroo Travel Packages', link: '/bonnaroo-music-festival-travel-packages' },
      {
        name: 'Boots and Hearts Travel Packages',
        link: '/boots-and-hearts-music-festival-travel-packages',
      },
      {
        name: 'BottleRock Napa Valley Travel Packages',
        link: '/bottlerock-festival-travel-packages',
      },
      { name: 'Coachella Travel Packages', link: '/coachella-music-festival-travel-packages' },
      { name: 'Country Thunder Travel Packages', link: '/country-thunder-travel-packages' },
      { name: 'Faster Horses Travel Packages', link: '/electric-daisy-carnival-travel-packages' },
      { name: 'Lollapalooza Travel Packages', link: '/lollapalooza-travel-packages' },
      {
        name: 'Ultra Music Festival Travel Packages',
        link: '/ultra-music-festival-travel-packages',
      },
    ],
  },
  {
    title: 'Events',
    links: [
      { name: 'Super Bowl Travel Packages', link: '/nfl-travel-packages/super-bowl' },
      {
        name: 'Daytona 500 Travel Packages',
        link: '/nascar-travel-packages/daytona-500',
      },
      { name: 'NBA All Star Game Travel Packages', link: '/nba-travel-packages/nba-all-star-game' },
      {
        name: 'Final Four Travel Packages',
        link: '/college-basketball-travel-packages/ncaa-mens-final-four',
      },
      { name: 'MLB All Star Game Travel Packages', link: '/mlb-travel-packages/mlb-all-star-game' },
      {
        name: 'U.S. Open Tennis Travel Packages',
        link: '/tennis-travel-packages/us-open-tennis-championship',
      },
      {
        name: 'The Masters Travel Packages',
        link: '/pga-tour-travel-packages/masters-golf-tournament',
      },
      {
        name: 'Waste Management Phoenix Open Travel Packages',
        link: '/pga-tour-travel-packages/waste-management-phoenix-open',
      },
      { name: 'CFL Grey Cup Travel Packages', link: '/cfl-travel-packages/cfl-grey-cup' },
    ],
  },
]

export const socialsData = [
  {
    image: Facebook,
    link: 'https://www.facebook.com/bookseatscom/',
  },
  {
    image: Twitter,
    link: 'https://x.com/BookSeatscom',
  },
  {
    image: Instagram,
    link: 'https://www.instagram.com/BookSeatscom/',
  },
]
